export default __webpack_public_path__ + "static/media/person.a99c0000.png";